// Ícone 📄 da barra de mensagem: escolhe um manual (cadastrado no menu Manuais) da fila do ticket.
// Ao escolher, os arquivos e o texto ficam prontos no campo (o envio continua manual).
import React, { useEffect, useState } from "react";
import {
  CircularProgress, Dialog, DialogContent, DialogTitle, IconButton, InputAdornment,
  List, ListItem, ListItemText, TextField, Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";

import suporteApi from "../../suporte/api";

const icone = (nome) => {
  if (/\.pdf$/i.test(nome)) return "📄";
  if (/\.(jpe?g|png|webp|gif)$/i.test(nome)) return "🖼️";
  if (/\.(mp4|mov|m4v|3gp|webm)$/i.test(nome)) return "🎥";
  return "📎";
};

const EscolherManual = ({ open, onClose, queueId, onEscolher }) => {
  const [lista, setLista] = useState(null);
  const [busca, setBusca] = useState("");

  useEffect(() => {
    if (!open) return;
    setBusca("");
    setLista(null);
    suporteApi.get("/api/manuais", { params: { fila: queueId || undefined } })
      .then((r) => setLista(r.data)).catch(() => setLista([]));
  }, [open, queueId]);

  const t = busca.trim().toLowerCase();
  const visiveis = (lista || []).filter((m) => !t || `${m.titulo} ${m.mensagem || ""} ${(m.tags || []).join(" ")} ${(m.arquivos || []).map((a) => a.nome).join(" ")}`
    .toLowerCase().includes(t));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle disableTypography style={{ display: "flex", alignItems: "center", paddingBottom: 4 }}>
        <Typography variant="h6" style={{ flex: 1 }}>Enviar manual</Typography>
        <IconButton size="small" onClick={onClose}><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField autoFocus fullWidth size="small" variant="outlined" placeholder="Buscar manual (título, tag, cliente, marca…)" value={busca}
          onChange={(e) => setBusca(e.target.value)}
          InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }} />
        {!lista && <CircularProgress size={24} style={{ marginTop: 12 }} />}
        {lista && !visiveis.length && (
          <Typography color="textSecondary" style={{ padding: 12 }}>
            Nenhum manual para esta fila. Cadastre em Suporte → Manuais.
          </Typography>
        )}
        <List dense>
          {visiveis.map((m) => (
            <ListItem key={m.id} button divider onClick={() => { onEscolher(m); onClose(); }} style={{ alignItems: "flex-start" }}>
              <ListItemText
                primary={<b>{m.titulo}</b>}
                secondary={
                  <>
                    {/* só a 1ª linha do texto; as tags não aparecem aqui, mas entram na busca */}
                    {m.mensagem && (
                      <span style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {m.mensagem.split("\n").find((l) => l.trim())}
                      </span>
                    )}
                    <span style={{ display: "block", fontSize: 12, marginTop: 2, opacity: 0.8, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {(m.arquivos || []).map((a) => `${icone(a.nome)} ${a.nome}`).join("  ·  ")}
                    </span>
                  </>
                }
                secondaryTypographyProps={{ component: "div" }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default EscolherManual;
